import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchMobileApps } from 'modules/mobileApps/actions';
import { selectMobileApps } from 'modules/mobileApps/selectors';
import { PLACEMENT_DISPLAY_CONTENT } from 'modules/placements/constants';
import { EmptyStateEmbedded } from 'ui/illustrations';
import { H4, WebLink } from 'ui/theme';
import { EmptyStateContainer, EmptyStateSecondaryText } from './styles';

const {
  emptyState: {
    appsWebsitesLinkText,
    appsWebsitesPath,
    documentationLinkText,
    documentationLinkTextPrefix,
    headerText,
    noDestinationsBodyText,
    noPlacementsBodyText,
  },
  placementsDocumentationPath,
} = PLACEMENT_DISPLAY_CONTENT;

export const PlacementsEmptyState = () => {
  const dispatch = useDispatch();
  const hasAppsOrWebsites = !!useSelector(selectMobileApps)?.length;

  const noPlacementsBodyTextWithLinkPrefix = `${noPlacementsBodyText} ${documentationLinkTextPrefix}`;

  const bodyText = !hasAppsOrWebsites ? noDestinationsBodyText : noPlacementsBodyTextWithLinkPrefix;
  const ctaLinkPath = !hasAppsOrWebsites ? appsWebsitesPath : placementsDocumentationPath;
  const ctaLinkText = !hasAppsOrWebsites ? appsWebsitesLinkText : documentationLinkText;

  useEffect(() => {
    dispatch(fetchMobileApps());
  }, []);

  return (
    <EmptyStateContainer data-test="placements-empty-state">
      <EmptyStateEmbedded />
      <H4>{headerText}</H4>
      <EmptyStateSecondaryText>
        {bodyText}
        <WebLink href={ctaLinkPath} rel="noreferrer noopener" target="_blank">
          {ctaLinkText}
        </WebLink>
        .
      </EmptyStateSecondaryText>
    </EmptyStateContainer>
  );
};
